import { useQuery } from "@tanstack/react-query";
import { getItems } from "../api/items";
import { ChartSeriesConfig } from "./types";

// Cor de cada serviço vem da ficha em `services.color` (hex, definida no Directus). As séries por
// serviço das dashboards devem ser chaveadas pelo ID do serviço (não pelo nome), por isso mapeamos
// serviceId -> cor e recolorimos as séries por chave — assim o mesmo serviço tem sempre a mesma cor
// em todas as dashboards. Espelha technicianColors.ts.
export const SERVICE_COLOR_FIELDS = "id,color";

const FIVE_MINUTES = 5 * 60 * 1000;

type ServiceColorRecord = {
    id?: number | string | null;
    color?: string | null;
};

// Mapa serviceId -> cor. Serviços sem cor definida (null) ficam de fora para o gráfico cair na paleta de reserva.
export const buildServiceColorById = (services: Array<ServiceColorRecord>) => {
    const colorById: Record<string, string> = {};
    services.forEach((service) => {
        if (service.id === null || service.id === undefined || !service.color) return;
        colorById[String(service.id)] = service.color;
    });
    return colorById;
};

// Recolore as séries por serviço com a cor do serviço quando existe; mantém a cor original — paleta de
// reserva (serviço sem cor) ou cor fixa de linhas agregadas — quando a chave não corresponde.
export const applyServiceSeriesColors = (series: Array<ChartSeriesConfig>, colorById: Record<string, string>) => {
    const recoloredSeries = series.map((serie) => {
        const color = colorById[serie.key] || serie.color;
        const nextSerie = { ...serie, color };
        return nextSerie;
    });
    return recoloredSeries;
};

// Obtém as cores dos serviços ao vivo (chave própria para não colidir com outros fetches de `services`).
// Se o visualizador não tiver leitura em `services`, devolve mapa vazio e os gráficos usam a paleta de reserva.
export const useServiceColors = () => {
    const servicesResult = useQuery({
        queryKey: ["dashboard-service-colors", SERVICE_COLOR_FIELDS],
        queryFn: () => getItems("services", SERVICE_COLOR_FIELDS, { pageSize: 300, sort: "id" }),
        staleTime: FIVE_MINUTES,
        keepPreviousData: true,
    });
    const serviceColorById = buildServiceColorById(servicesResult.data?.items || []);
    const result = { serviceColorById, isLoading: servicesResult.isLoading };
    return result;
};
